<template>
  <div class="card" v-if="loaded">
    <h3 class="bold text-primary" style="margin-bottom:6px">{{$t("Latest notifications")}}</h3>
    <hr class="text-primary" />
    <div class="md-layout">
      <template v-if="model.items.length">
        <div
          v-for="item in model.items"
          :key="item.id"
          style="margin:0px 0px;"
          class="md-layout-item md-size-100"
        >
          <div class="notification-item" @click="showDetails(item)">
            <span class="text-gray regular" style="font-size:18px">
              <md-icon v-if="!item.isRead" class="text-primary normal">new_releases</md-icon>
              <md-icon class="text-primary">{{item.icon | icon}}</md-icon>
              {{item.description.title}}
            </span>
          </div>
        </div>

        <div class="md-layout md-layout-item md-size-100" style="margin-top:15px">
          <div class="ml-auto">
            <md-button
              @click.prevent="$router.push({name:'notifications'})"
              class="md-round md-primary md-sm md-blue-border"
              style="margin:0px"
            >{{$t('Show more notifications')}}</md-button>
          </div>
        </div>
      </template>

      <no-data v-else class="md-layout-item md-size-100" />
    </div>

    <div class="modal modal-bg" :class="{ show: selectedItem }">
      <modal v-if="selectedItem" @close="selectedItem = null">
        <template slot="header">
          <h3 class="title" style="margin:0px">
            <md-icon style="margin-right:4px" class="text-primary">{{selectedItem.icon | icon}}</md-icon>
            {{selectedItem.description.title}}
          </h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedItem = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <p style="text-align:left">{{selectedItem.description.content}}</p>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "@/util/axios";
import { mapGetters, mapActions } from "vuex";
import { Modal } from "@/components";
import NoData from "@/pages/authenticated/NoData";

export default {
  components: { Modal, NoData },
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },
  data() {
    return {
      loaded: false,
      selectedItem: null,
      model: {
        notReadCount: 0,
        items: []
      }
    };
  },
  methods: {
    ...mapActions({ refreshNotificationsCount: "notifications/refresh" }),
    async loadData() {
      this.model = (
        await axios.get("public/conferences/conference/notifications", {
          params: {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code,
            count: 5
          }
        })
      ).data;
      this.loaded = true;
    },
    async showDetails(item) {
      await axios.post("public/myprofile/notifications/read/add", {
        id: item.id
      });

      this.selectedItem = item;
      item.isRead = true;

      await this.refreshNotificationsCount();
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      this.model.items = [];
      await this.loadData();
    }
  }
};
</script>
<style lang="scss" scoped>
.notification-item {
  cursor: pointer;
  margin: 0px 0px;
  padding: 7px 0px;
  &:hover {
    box-shadow: 0px 0px 30px #0000000d;
    border-radius: 15px;
    opacity: 1;
  }
}
</style>
